<template>
    <section :id="`element-${settings.id}`" :class="classes" :style="{ backgroundColor: settings?.color }">
        <div class="container">
            <div class="grid12">
                <div class="l-col">
                    <UiHeadline
                        :settings="{
                            label: settings?.label,
                            headline: settings?.headline
                        }"
                    >
                        <template #additional>
                            <div v-if="settings?.body" class="content typography" v-html="props.settings?.body" />
                            <div v-if="!!settings?.linkUrl.length" class="buttons">
                                <UiLink :link="settings?.linkUrl[0]" :style="'transparent w-border'" />
                            </div>
                        </template>
                    </UiHeadline>
                </div>
                <div class="r-col">
                    <UiMediaWithVideo :media="settings?.media" :video="settings?.video" wrapper-class="w-ratio" image-classes="responsive full" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});

const classes = computed(() => (props.settings?.reverse ? 'elle-media-text padd-v reverse' : 'elle-media-text padd-v'));
</script>
